// TODO: (important) Finalize this file and remove eslint-disable after approval has been confirmed. Extract any remaining text from the file and add it to the appropriate i18n file.
/* eslint-disable react/no-danger */
/* eslint-disable react/button-has-type */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';

import i18n from 'i18n-react';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import logo from 'assets/images/megaFam.png';

import ContentHeader from 'components/ContentHeader';
import DashboardChart from 'components/DashboardChart';
import RewardMenu from 'components/RewardMenu';

import APIHandler from 'config/APIHandler';
import StorageHandler from 'config/StorageHandler';

import BadgeContainer from 'views/BadgeView/BadgeContainer';
import Badge from 'views/BadgeView/IncentiveBadge';

import BookingState from '../BookingsView/BookingState';
// eslint-disable-next-line import/order
import { baseAppId, storageKeys } from 'settings';

export default class DashboardView extends Component {
  constructor() {
    super();

    this.state = {
      loading: false,
      bookings: [],
      contests: [],
      show: {},
      activeBtn: 'View All',
      currentYear: new Date().getFullYear(),
      filterSubmissionDate: 'currentYear',
    };

    this.setFilter = this.setFilter.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
  }

  async componentDidMount() {
    this.getBookingsData();
    this.getIncentivesData();
  }

  getBookingsData = () => {
    try {
      this.setState({ loading: true });
      StorageHandler.load(storageKeys.accessToken).then(async (token) => {
        const result = await APIHandler.getRewards(baseAppId, token);

        const { response: bookings } = result;

        if (Array.isArray(bookings) && bookings.length > 0) {
          this.setState({
            bookings,
            show: {
              showKey: 'View All',
              'View All': true,
              data: [...bookings],
            },
            loading: false,
          });
        }
        this.setState({ loading: false });
      });
    } catch (error) {
      this.setState({ bookings: [], loading: false });
    }
  };

  getIncentivesData = () => {
    try {
      StorageHandler.load(storageKeys.lang).then(async (lang) => {
        const result = await APIHandler.getContests(baseAppId, {
          currentDate: new Date().toISOString(),
          marketFilter: [{ id: lang.code.toUpperCase() }],
        });
        if (Array.isArray(result) && result.length > 0) {
          this.setState({ contests: result });
        }
      });
    } catch (error) {
      this.setState({ contests: [] });
    }
  };

  setShow = (key, booking) => {
    const { show } = this.state;

    this.setState({ activeBtn: key });

    const updatedShow = Object.keys(show).reduce((acc, item) => {
      acc[item] = item === key;
      return acc;
    }, {});

    if (booking.length >= 0) {
      updatedShow.showKey = key;
      updatedShow.data = [...booking];

      this.setState({ show: updatedShow });
    }
  };

  setFilter(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  applyFilter = (data) => {
    const {filterSubmissionDate, currentYear} = this.state;
    if(filterSubmissionDate === "currentYear"){
      return data?.filter((booking) => booking && new Date(booking.created_at).getFullYear().toString().includes(currentYear))  
    }
    else if(filterSubmissionDate === "previousYears"){
      return data?.filter((booking) => booking && !(new Date(booking.created_at).getFullYear().toString().includes(currentYear)))
    }
    return data;
  }

  render() {
    const { loading, bookings, contests, show, activeBtn, filterSubmissionDate, currentYear } = this.state;

    const columns = [
      {
        name: 'Submission Date',
        selector: (row) => new Date(row.created_at).toLocaleDateString(),
        sortable: true,
      },
      {
        name: 'Confirm Number',
        selector: (row) => row.booking_number,
        sortable: true,
      },
      {
        name: 'Flight Number',
        selector: (row) => row.reservation_number,
        sortable: true,
      },
      {
        name: 'Status',
        selector: (row) => row.status,
        sortable: true,
      },
      {
        name: 'Departure Date',
        selector: (row) => new Date(row.arrival_date).toLocaleDateString(),
        sortable: true,
        hide: 'sm',
      },
      {
        name: 'Return Date',
        selector: (row) => new Date(row.departure_date).toLocaleDateString(),
        sortable: true,
        hide: 'sm',
      },
      {
        name: 'Total Nights',
        selector: (row) => row.length_of_stay,
        sortable: true,
      },
      {
        name: 'Last Name',
        selector: (row) => row.agent_last_name,
        sortable: true,
      },
      {
        name: 'Total Travelers',
        selector: (row) => row.number_of_guests,
        sortable: true,
        hide: 'md',
      },
    ];

    const params = new URLSearchParams(window.location.search);
    let mobile = false;
    if (params.get('mobile')) {
      mobile = true;
    }

    return (
      <div className="contentContainer dashboardView">
        <RewardMenu />

        <section className="headerFirst">
          <ContentHeader
            header={i18n.translate('rewards.dashboardView.title')}
            subtitle={i18n.translate('rewards.dashboardView.subtitle')}
          />
        </section>

        <hr />

        <ContentHeader header={i18n.translate('rewards.dashboardView.badge')} subtitle="" />
        <BadgeContainer key="dash-badge-container" showLine>
          {contests.map(({ id, title, image, url, micro_app_id: microAppId }) => (
            <div key={id} className="dash-badge">
              <Badge badgeImg={image} title={title} rounded lockLinkUrl={url} microAppId={microAppId} />
            </div>
          ))}
        </BadgeContainer>
        {contests.length === 0 && (
          <div className="noDashBadge">
            <p>{i18n.translate('rewards.dashboardView.noBadgeIncentives')}</p>
            <br />
          </div>
        )}
        <hr />
        <ContentHeader header={i18n.translate('rewards.dashboardView.activity')} subtitle=""/>
        <div className={`DashboardView ${loading ? 'overflow-hidden' : ''}`}>
          <div className="dashboardHolder">
            <div className="progress">
              {!loading && (
                <React.Fragment>
                  <div className="tableNav">
                    {Object.entries(BookingState)
                      .sort(([, valueA], [, valueB]) => valueB - valueA)
                      .map(([key]) => {
                        const booking = bookings
                          .filter(({ status }) => BookingState[key].status.includes(status));

                        return (
                          <div key={key} onClick={() => this.setShow(key, booking)}>
                            <button className={activeBtn === key ? 'btn active' : 'btn'}>
                              {key === 'Approved Entries' && <FontAwesomeIcon icon={['fas', 'check']} />}
                              {key === 'Pending Entries' && <FontAwesomeIcon icon={['fas', 'clock']} />}
                              {key === 'Declined Entries' && <FontAwesomeIcon icon={['fas', 'ban']} />}
                              {key === 'View All' && <FontAwesomeIcon icon={['fas', 'th-list']} />}

                              <span>{this.applyFilter(booking).length}</span>
                              <span
                                className="head"
                                dangerouslySetInnerHTML={{
                                  __html: i18n
                                    .translate(
                                      `rewards.dashboardView.state.${key
                                        .split(' ')
                                        .join('')
                                        .replace(/^./, (str) => str.toLowerCase())}`,
                                    )
                                    .replace(' ', '<br/>'),
                                }}
                              />
                            </button>
                          </div>
                        );
                      })}
                  </div>
                  <p className="info-message">{i18n.translate('rewards.bookingsView.infoMessage')}</p>

                  <div className='bookings-table__header'>
                    <ContentHeader
                      header={i18n.translate('rewards.dashboardView.manage')}
                      subtitle={i18n.translate('rewards.dashboardView.manageSub')}
                    />
                    {!loading &&         
                      <div className='bookings-date-select__container'>
                        <select className='bookings-date-select' name="filterSubmissionDate" value={filterSubmissionDate} onChange={this.setFilter}>
                          <option default value={"currentYear"}>{i18n.translate('rewards.dashboardView.currentYear')}</option>
                          <option value={"previousYears"}>{i18n.translate('rewards.dashboardView.archivedBookings')}</option>
                        </select>
                      </div>
                    }
                  </div>
                  <div className="table-booking">
                    <DataTable
                      className="bookings-table"
                      columns={columns}
                      data={this.applyFilter(show?.data)}
                      defaultSortFieldId={1}
                      noDataComponent={
                        <div>
                          <br />
                          {i18n.translate('rewards.dashboardView.noBookings')}
                          <br />
                          <br />
                        </div>
                      }
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>

        {mobile && (
          <style>
            {
              '\
      .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }'
            }
          </style>
        )}
      </div>
    );
  }
}
